<template>
  <div :class="{'hidden':hidden}" class="pagination-container">
    <el-pagination
      :background="background"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      :layout="layout"
      :page-sizes="pageSizes"
      :total="total"
      v-bind="$attrs"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
import { scrollTo } from '@Sample~/utils/scroll-to'

export default {
  name: 'Pagination',
  props: {
    total: {
      required: true,
      type: Number
    },
    page: {
      type: Number,
      default: 1
    },
    limit: {
      type: Number,
      default: 20
    },
    pageSizes: {
      type: Array,
      default() {
        return [10, 20, 30, 50, 100]
      }
    },
    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper'
    },
    background: {
      type: Boolean,
      default: true
    },
    autoScroll: {
      type: Boolean,
      default: true
    },
    hidden: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentPage: {
      get() {
        return this.page
      },
      set(val) {
        this.$emit('update:page', val)
      }
    },
    pageSize: {
      get() {
        return this.limit
      },
      set(val) {
        this.$emit('update:limit', val)
      }
    }
  },
  methods: {
    handleSizeChange(val) {
      this.$emit('pagination', { page: this.currentPage, limit: val })
      if (this.autoScroll) {
        scrollTo(0, 800)
      }
    },
    handleCurrentChange(val) {
      this.$emit('pagination', { page: val, limit: this.pageSize })
      if (this.autoScroll) {
        scrollTo(0, 800)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.pagination-container.hidden {
  display: none;
}
.pagination-container {
  background: #fff;
  padding: 32px 16px;
  text-align: right;
}
// 总页码
::v-deep .el-pagination__total{
  color: #666666;
}
::v-deep .el-pagination__sizes{
  .el-input__inner{
    background: #FFFFFF;
    box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.04);
    border-radius: 4px;
    border: 1px solid #EEEEEE;
  }
}

::v-deep .el-icon-arrow-up:before {
    content: "\E78F";
    color: #666;
}

::v-deep.el-icon-arrow-left:before{
    content: "\e792";
    color: #666;
}

::v-deep.el-icon-arrow-right:before{
    content: "\e791";
    color: #666;
}
</style>
